/**
 * Endpoint catalog mirrored from blueprint §5. Centralized so web and mobile
 * never hard-code paths and the API can verify route coverage in tests.
 */
export const API_BASE = '/api/v1';

export const endpoints = {
  // Auth
  login: () => `${API_BASE}/auth/login`,
  refresh: () => `${API_BASE}/auth/refresh`,
  logout: () => `${API_BASE}/auth/logout`,
  mfaEnroll: () => `${API_BASE}/auth/mfa/enroll`,
  mfaVerify: () => `${API_BASE}/auth/mfa/verify`,
  mfaDisable: () => `${API_BASE}/auth/mfa/disable`,

  // Users (MASTER-managed)
  users: () => `${API_BASE}/users`,
  user: (id: string) => `${API_BASE}/users/${id}`,
  userResetPassword: (id: string) => `${API_BASE}/users/${id}/reset-password`,
  userSuspend: (id: string) => `${API_BASE}/users/${id}/suspend`,
  userActivate: () => `${API_BASE}/users/activate`,

  // Projects
  projects: () => `${API_BASE}/projects`,
  project: (id: string) => `${API_BASE}/projects/${id}`,
  projectArchive: (id: string) => `${API_BASE}/projects/${id}/archive`,
  projectMembers: (id: string) => `${API_BASE}/projects/${id}/members`,
  projectMember: (id: string, userId: string) => `${API_BASE}/projects/${id}/members/${userId}`,
  projectActivity: (id: string) => `${API_BASE}/projects/${id}/activity`,

  // Flowcharts
  projectFlowcharts: (projectId: string) => `${API_BASE}/projects/${projectId}/flowcharts`,
  flowchart: (id: string) => `${API_BASE}/flowcharts/${id}`,
  flowchartClone: (id: string) => `${API_BASE}/flowcharts/${id}/clone`,
  flowchartPublish: (id: string) => `${API_BASE}/flowcharts/${id}/publish`,
  flowchartStages: (id: string) => `${API_BASE}/flowcharts/${id}/stages`,
  flowchartTransitions: (id: string) => `${API_BASE}/flowcharts/${id}/transitions`,
  flowchartMigrate: (id: string) => `${API_BASE}/flowcharts/${id}/migrate-leads`,
  stage: (id: string) => `${API_BASE}/stages/${id}`,

  // Leads
  projectLeads: (projectId: string) => `${API_BASE}/projects/${projectId}/leads`,
  lead: (id: string) => `${API_BASE}/leads/${id}`,
  leadMove: (id: string) => `${API_BASE}/leads/${id}/move`,
  leadAssign: (id: string) => `${API_BASE}/leads/${id}/assign`,
  leadHistory: (id: string) => `${API_BASE}/leads/${id}/history`,
  leadArchive: (id: string) => `${API_BASE}/leads/${id}/archive`,

  // Comments
  leadComments: (id: string) => `${API_BASE}/leads/${id}/comments`,
  comment: (id: string) => `${API_BASE}/comments/${id}`,

  // Documents
  documentInit: (leadId: string) => `${API_BASE}/leads/${leadId}/documents/init`,
  documentFinalize: (leadId: string) => `${API_BASE}/leads/${leadId}/documents/finalize`,
  leadDocuments: (leadId: string) => `${API_BASE}/leads/${leadId}/documents`,
  documentDownload: (id: string) => `${API_BASE}/documents/${id}/download`,
  document: (id: string) => `${API_BASE}/documents/${id}`,

  // Reminders & notifications
  leadReminders: (leadId: string) => `${API_BASE}/leads/${leadId}/reminders`,
  myReminders: () => `${API_BASE}/reminders/me`,
  reminderComplete: (id: string) => `${API_BASE}/reminders/${id}/complete`,
  notifications: () => `${API_BASE}/notifications`,
  notificationRead: (id: string) => `${API_BASE}/notifications/${id}/read`,
  notificationSubscriptions: () => `${API_BASE}/me/notification-subscriptions`,
  pushDevices: () => `${API_BASE}/push-devices`,
  pushDevice: (id: string) => `${API_BASE}/push-devices/${id}`,

  // Audit
  activity: () => `${API_BASE}/activity`,
} as const;
